import React from 'react';
import LineChart, {chartContent, ChartMonthData} from "../../../../common/component/LineChart";
import {QueryKey} from "@tanstack/react-query";
import {useCommonUseQuery} from "../../../../../../../Common/hooks/rest/ReacQueryHook";
import {procAdminService} from "../../../../../../../Common/util/ProcService";

const ThisMonthSizeDashBoard: React.FC = () => {
    const serviceCode:string       =   process.env.REACT_APP_SERVICE_NAME as string;
    const queryKey:QueryKey =   ["ThisMonthSizeDashBoardKey"];
    const { data } = useCommonUseQuery<ChartMonthData>(
        queryKey,
        () =>procAdminService<ChartMonthData>("post", `${serviceCode}ADS02`, null));

    const monthCategory = data ? data.monthCategory :
                                        [
                                            '01','02','03','04','05','06',
                                            '07','08','09','10','11','12',
                                            '13','14','15','16','17','18',
                                            '19','20','21','22','23','24',
                                            '25','26','27','28','29','30',
                                        ]

    const monthSeries:chartContent[] = [
                                            data ? data.data :
                                            {
                                                name: "이번달",
                                                data: [
                                                    0,0,0,0,0,0,
                                                    0,0,0,0,0,0,
                                                    0,0,0,0,0,0,
                                                    0,0,0,0,0,0,
                                                    0,0,0,0,0,0,
                                                ]
                                            },
    ]



    return (
        <LineChart title="이번달 업로드 현황 (용량-MB)" key={2} unit="MB" categories={monthCategory} series={monthSeries} dataLabels={true}/>
    );
};

export default ThisMonthSizeDashBoard;
